import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function EmailSent({ forgotPassword = false, changeEmail = false }) {
  // variables
  const Navigate = useNavigate();

  // functions
  const handleConfirmation = () => {
    if (changeEmail) {
      Navigate('/my-account');
      return;
    }

    Navigate('/');
  };

  return (
    <main className="d-flex w-100 h-100 login-background">
      <div className="container d-flex flex-column">
        <div className="vh-100">
          <div className="mx-auto d-table h-100 w-50">
            <div className="d-table-cell align-middle">
              <Box className="mx-auto text-center mb-3">
                <img
                  className="img-fluid mb-4"
                  width="180"
                  height="48"
                  src="/img/logo.png"
                  alt="ビルドセルフ - BUILD-SELF"
                />
                <h3 className="text-bold my-3">
                  {forgotPassword && 'パスワード再設定のURLを送信いたしました'}
                  {changeEmail && 'メールアドレス変更のURLを送信いたしました'}
                  {!forgotPassword && !changeEmail && '本人確認用メールを送信いたしました'}
                </h3>
                {!forgotPassword && !changeEmail && (

                  <Box
                    className="my-3"
                    sx={{
                      border: '2px solid #dc3545',
                      padding: '0.5rem',
                    }}
                  >
                    <Typography
                      fontSize={12}
                      color="#dc3545"
                    >
                      <FontAwesomeIcon icon={faCircleExclamation} className="mx-2" />
                      <span>まだ会員登録は完了しておりません</span>
                    </Typography>
                  </Box>
                )}
                <Box className="card">
                  <Box className="card-body">
                    {!forgotPassword && !changeEmail && (
                      <p className="text-start">
                        ご入力いただいたメールアドレスに会員登録用のURLをメール送信しましたのでご確認ください。
                        <br />
                        <br />
                        しばらく経ってもメールが届かない場合は、迷惑フォルダに入っているか、間違ったメールアドレスを入力されたか可能性があります。ご確認をお願いいたします。
                        <br />
                        <br />
                      </p>
                    )}
                    {forgotPassword && (
                      <p className="text-start">
                        ご登録メールアドレスにパスワード再設定のURLをお送りしましたのでご確認ください。
                        <br />
                        <br />
                        しばらく経ってもメールが届かない場合は、迷惑フォルダに入っているか、間違ったメールアドレスを入力されたか可能性があります。ご確認をお願いいたします。
                        <br />
                        <br />
                      </p>
                    )}
                    <Button
                      sx={{
                        fontSize: '0.8rem',
                      }}
                      onClick={handleConfirmation}
                      variant="contained"
                    >
                      トップへ戻る
                    </Button>
                  </Box>
                </Box>
              </Box>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default EmailSent;
